import axios from "axios";
import  axiosInstance  from "./axiosInstance.ts";


export interface UserFormData {
  userName: string;
  password: string;
}

export interface LoginSuccessResponse {
  access_token: string;
  refresh_token?: string;
  token_type: string;
  expires_in?: number;
}

export interface LoginFailResponse {
  error: string;
  message: string;
}


export const auth = {
  login: (userformData: UserFormData) =>
    // axiosInstance.post(
    //   "api/v1/login/access-token",
    //   ({
    //     username: userformData.userName,
    //     password: userformData.password,
    //   }),
    //   {
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //     },
    //   }
    // ),
     axiosInstance.post(
      // "api/v1/login/access-token",
      `${window.env.REACT_APP_UMP_AUTH_URL}/login`,
      ({
        username: userformData.userName,
        password: userformData.password,
      }),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    ),
    getUser:() =>{ 
      return axiosInstance.get(
      `${window.env.REACT_APP_UMP_URL}/user/${sessionStorage.getItem("userName")}`
    )},
    signIn: (username) => {
    return axios.get(`${window.env.REACT_APP_UMP_AUTH_URL}/rbac/${username}`)
  }
};


